import React, { useState } from 'react';
import styles from './InsuranceExportsListItem.module.scss';
import {
	InsuranceExport,
	InsuranceReportType,
	useCreateInsuranceReportExportFilesMutation,
} from '../../../../graphql/graphql';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import useNotification from '../../../../Hooks/useNotification.hook';
import { joinClasses } from '../../../../Utils/className.util';
import Text from '../../../../Components/Base/Text/Text';
import InsuranceExportedBatchesListModal from '../InsuranceExportedBatches/InsuranceExportedBatchesListModal';

interface Props {
	item: InsuranceExport;
	rootWorkplaceId: string;
	workplaceId: string;
}

const InsuranceExportsListItem: React.FC<Props> = ({
	item,
	rootWorkplaceId,
	workplaceId,
}) => {
	const [isBatchListOpen, setIsBatchListOpen] = useState(false);
	const [createInsuranceReportExport] =
		useCreateInsuranceReportExportFilesMutation();
	const { showNotificationSuccess } = useNotification();

	const handleExport = async () => {
		const result = await createInsuranceReportExport({
			input: {
				rootWorkplaceId,
				insuranceCompanyCode: item.insuranceCompanyCode!,
				month: item.periodMonth,
				year: item.periodYear,
				type: InsuranceReportType.Correction,
			},
		});

		if ('data' in result) {
			showNotificationSuccess({
				content: 'component.insuranceCompanyInsuranceExportGen.successMessage',
			});
		}
	};

	return (
		<>
			<div
				className={joinClasses([
					styles.wrapper,
					item.needCorrection ? styles.invalid : '',
				])}>
				<div className={styles.date}>
					<div>
						<FormattedMomentDate
							date={item.exportFile.createdAt}
							format={DateFormat.DATE_TIME}
						/>
					</div>
				</div>
				<div className={styles.content}>
					<div className={styles.items}>
						<div className={styles.item}>
							<Text
								tx='component.insuranceExportedBatchesListItem.insuranceCompany'
								className={styles.label}
								colon
							/>
							<div>{item.insuranceCompanyTerm?.name}</div>
						</div>
						<div className={styles.item}>
							<Text
								tx='component.insuranceExportedBatchesListItem.period'
								className={styles.label}
								colon
							/>
							<div>
								{item.periodMonth}/{item.periodYear}
							</div>
						</div>
					</div>
				</div>
				<div className={styles.controls}>
					{item.needCorrection && (
						<LinkButton
							theme={Theme.BLUE}
							title='component.insuranceExportedBatchesListItem.exportCorrectionFile'
							onClick={handleExport}
						/>
					)}
					{item.exportFile?.fileUrl && (
						<LinkButton
							title='component.insuranceExportedBatchesListItem.download'
							theme={Theme.BLUE}
							href={item.exportFile.fileUrl}
						/>
					)}
					<LinkButton
						title='component.insuranceExportedBatchesListItem.detail'
						theme={Theme.BLUE}
						onClick={() => setIsBatchListOpen(true)}
					/>
				</div>
			</div>
			{isBatchListOpen && (
				<InsuranceExportedBatchesListModal
					isOpen
					workplaceId={workplaceId}
					rootWorkplaceId={rootWorkplaceId}
					exportFile={item.exportFile}
					onClose={() => setIsBatchListOpen(false)}
				/>
			)}
		</>
	);
};

export default InsuranceExportsListItem;
